import axios from 'axios'
import store from '../store'
import local from '../../vue.config.local.js'

export default {
  // 서버와 통신하는 api
  serverURI: store.state.APISERVER,
  request (method, uri, data = null) {
    if (!method) {
      console.error('API function call requires method argument')
      return
    }

    if (!uri) {
      console.error('API function call requires uri argument')
      return
    }

    var url = this.serverURI + uri

    return axios({ method, url, data })
    // return axios(config1)
  },
  fileUpload (formData) {
    const url = this.serverURI + '/cdn/upload'
    return axios.post(url, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
    // get data
      .then(x => x.data.files)
  },
  docId (docType, id) {
    return this.currentTerm() + '-' + docType + '-' + id
  },
  currentTerm () {
    var date = new Date()
    var dateYear = date.getFullYear()
    var term = ''
    /* 3 ~ 8월 : 2nd */
    if (date.getMonth() + 1 < 9 && date.getMonth() + 1 > 2) {
      term = '2nd'
    } else if (date.getMonth() + 1 >= 9) {
      /* 9 ~ 12월 : 1st 인데 year은 그다음해 */
      term = '1st'
      dateYear = String(Number(dateYear) + 1)
    } else {
      /* 1 ~ 2월: 1st year은 변화x */
      term = '1st'
    }

    return dateYear + '-' + term
  },
  currentUnixTime () {
    var date = new Date()
    return date.getTime()
  },
  unixTimeToDate (timestamp) {
    if (!timestamp) {
      return ''
    }
    var date = new Date(timestamp)
    return date.getMonth() + 1 + '.' + date.getDate() + ' ' + date.getHours() + ':' + date.getMinutes()
  },
  defaultTitleList (part) {
    var titles = local.titleList.default.slice()
    if (part === '초등56부') {
      local.titleList.elementary.forEach(val => {
        titles.push(val)
      })
    } else if (part === '중등부') {
      local.titleList.middle.forEach(val => {
        titles.push(val)
      })
    } else if (part === '고등부') {
      local.titleList.high.forEach(val => {
        titles.push(val)
      })
    } else if (part === '대학부') {
      local.titleList.univ.forEach(val => {
        titles.push(val)
      })
    } else {
      local.titleList.else.forEach(val => {
        titles.push(val)
      })
    }

    return titles
  },
  nameTopic1 (key) {
    return local.topic1List[key] || local.topic1List['2024-1st']
  },
  nameTopic2 (key) {
    return local.topic2List[key] || local.topic2List['2024-1st']
  },
  ITSDETAIL: local.itsDetail,
  PARTLIST: local.partList,
  TRAININGLIST: local.trainingList,
  DONATEPARTLIST: local.donatePartList
}
